export const ENVIRONMENT: 'development' | 'production' | 'demo' = 'production'
export const REVISION: string = '986c5b5c0caa3fb96ce948ac830bebe2ad7b4b64'



// WEBPACK FOOTER //
// ./src/config/environment.ts